
export default {
    head() {
        return {
            title: this.campusInfo?.attributes?.metaTitleAtoutsAlt ? `${this.campusInfo?.attributes?.metaTitleAtoutsAlt}` : `ICFA - Les atouts de l'aternance - ${this.campusInfo?.attributes?.name}` ,
            meta: this.campusInfo?.attributes?.metaAtoutsAlt != null && this.campusInfo?.attributes?.metaAtoutsAlt != undefined ?
                JSON.parse(this.campusInfo?.attributes?.metaAtoutsAlt?.replace('\n', '')) : null
        };
        // return {
        //     title: `ICFA - Les atouts de l'aternance`,
        //     meta: [
        //         {
        //             hid: 'og-title',
        //             property: 'og:title',
        //             content: `Les atouts de l'aternance`,
        //         },
        //         // {
        //         //     hid: 'og-description',
        //         //     property: 'og:description',
        //         //     content: `Vous avez des questions sur nos formations en alternance? Contactez l'ICFA pour des conseils d'experts et des informations détaillées. Votre future carrière commence ici.`,
        //         // }
        //     ]
        // };
    },

    async asyncData({ params, $http, store }) {
        let instances = store.state.instances;

        const instance = instances.filter((instance) => {
            return instance.attributes.subFolderName == params.campusHP
        })[0];
        // console.log(instance?.attributes?.global);

        if (!store.state.instance) {
            store.commit('setInstance', instance)
        }

        let campusInfo = store.state.campusInfo;
        console.log(campusInfo?.attributes?.banniereTexe);

        let banniereLogoUrl = process.env.strapiBaseUri + campusInfo.attributes.banniereLogo?.data?.attributes?.url;

        let lesAtoutsCampus = await $http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes.prefix}-atouts-page`);
        lesAtoutsCampus = lesAtoutsCampus.data;


        return {
            instances, instance, campusInfo, banniereLogoUrl, lesAtoutsCampus
        }
    },
}
